import { makeActionCreator } from '../../../../utilities'
import { TitrateConstants } from './titrate.constants'

export const setMedication = makeActionCreator(TitrateConstants.SET_MEDICATION, 'medication')
export const setOtherOption = makeActionCreator(TitrateConstants.SET_OTHER_OPTION, 'otherOption')
export const setNewDose = makeActionCreator(TitrateConstants.SET_NEW_DOSE, 'newDose')
export const setRate = makeActionCreator(TitrateConstants.SET_RATE, 'rate')
export const setRatePNNV = makeActionCreator(TitrateConstants.SET_RATE_PNNV, 'ratePNNV')
export const setRoute = makeActionCreator(TitrateConstants.SET_ROUTE, 'route')
export const setRoutePNNV = makeActionCreator(TitrateConstants.SET_ROUTE_PNNV, 'routePNNV')
export const setUpdateInputRows = makeActionCreator(TitrateConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setAddToTimeLine = makeActionCreator(TitrateConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const saveTitrate = makeActionCreator(TitrateConstants.SAVE_TITRATE)
export const setTitrateState = makeActionCreator(TitrateConstants.SET_TITRATE_STATE, 'titrate')
export const resetTitrateState = makeActionCreator(TitrateConstants.RESET_TITRATE_STATE)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
